import React, { useState } from 'react';
import { Checkbox, Modal, Radio, Stack } from '@mantine/core';
import { MIME_TYPES } from '@mantine/dropzone';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Banner from '../../elements/Banner';
import Button from '../../elements/Button';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import LoadingBars from '../../elements/LoadingBars';
import Select from '../../fields/SelectBox';
import IconArrowDown from '../../icons/IconArrowDown';
import IconDownloadCsv from '../../icons/IconDownloadCsv';
import IconFailed from '../../icons/IconFailed';
import styles from './styles.scoped.css';

export default function Component({
  // history,
  navigate,
  handleSubmit,
  isBulk = false,
  isLoading,
  dataReason,
  dataReasonDetail,
  minute,
  second,
  isTooManyRequests
}) {
  const dispatch = useDispatch();
  const [modalReasonDetail, setModalReasonDetail] = useState(false);
  const [reasonDetailId, setReasonDetailId] = useState('');
  const [file, setFile] = useState([]);
  const [supportDocument, setSupportDocument] = useState(null);
  // const [requestUnblock, setRequestUnblock] = useState(null);
  const [error, setError] = useState('');
  const { values } = useSelector((state) => state.form.FormBlockedNik);


  const inputPropsReason = {
    label: 'Alasan Blokir Pelanggan',
    placeholder: 'Pilih alasan blokir pelanggan',
    data: dataReason.data.filter(item => item.isActive === true).map((item) => ({
      value: `${item.id}`,
      label: item.message
    })),
  };

  const inputPropsDescription = {
    label: 'Pesan Keterangan Blokir di MAP',
    placeholder: 'Pilih pesan keterangan blokir di MAP',
    info: 'Keterangan: ditampilkan ketika NIK terblokir melakukan transaksi atau pendaftaran di MAP',
    data: dataReasonDetail.data.filter(item => item.isActive === true).map((item) => ({
      value: `${item.id}`,
      label: item.message
    })),
    rightSection: <IconArrowDown />,
    readOnly: true,
  };

  // const inputRequestUnblock = {
  //   label: 'Kelayakan Pengajuan Buka Blokir',
  //   info: 'Pilih apakah pelanggan dapat mengajukan buka blokir atau tidak',
  //   data: [
  //     { value: '1', label: 'Pelanggan dapat mengajukan buka blokir' },
  //     { value: '0', label: 'Pelanggan tidak dapat mengajukan buka blokir' }
  //   ]
  // };

  const propsfile = {
    title: 'Dokumen Pendukung',
    name: 'file',
    maxSize: 20000000,
    info: 'Format file .doc, .docx atau .pdf dan tidak lebih dari 2 Mb',
    require: true
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      ...values, file, supportDocument,
      // requestUnblock
    });
  };

  const downloadTemplate = () => {
    window.open('https://storage.googleapis.com/fin-map-images-public-stage/templates/Template_list_NIK.csv');
  };

  const disabledButton = () => {
    return !values.agree || !values.reasonId || !values.reasonDetailId
     || isTooManyRequests;
  };

  const onSelect = (e) => {
    setSupportDocument(e[0]);
  };

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      {isBulk && (
        <ImagePicker
          accept={['text/csv']}
          downloadTemplate={downloadTemplate}
          IconDownloadTemplate={<IconDownloadCsv />}
          info={'Format file .csv dan tidak lebih dari 2 Mb'}
          maxSize={2000000}
          onSelect={setFile}
          required={true}
          title={'Unggah Data Pelanggan'}
          withDownloadTemplate={true}
        />
      )}
      <Field
        component={Select}
        required
        {...inputPropsReason}
        name="reasonId"
        onChange={(value) => dispatch(change('FormBlockedNik', 'reasonId', value))}
        rightSection={<IconArrowDown />}
        value={values.reasonId}
      />
      <div>
        <Field
          component={Select}
          required
          {...inputPropsDescription}
          name="reasonDetailId"
          onClick={() => setModalReasonDetail(true)}
          readOnly
          rightSection={<IconArrowDown />}
          value={values.reasonDetailId}
        />
        <span className={styles.info}>
          Keterangan: ditampilkan ketika NIK terblokir melakukan transaksi atau pendaftaran di MAP
        </span>
      </div>

      {/* <Stack spacing={0}>
        <Text fw={500}>Kelayakan Pengajuan Buka Blokir</Text>
        <Radio.Group onChange={(value) => setRequestUnblock(value)} value={requestUnblock}>
          <Stack>
            {inputRequestUnblock.data.map((item, index) => (
              <Radio checked={requestUnblock === item.value} key={index}
                label={item.label}
                styles={{
                  label: {
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#212121',
                    lineHeight: '20px',
                  },
                  body: {
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #D9DEE4',
                    borderRadius: '8px',
                    padding: '0.3rem .5rem',
                  },
                  // inner: {
                  //   padding: '0.5rem',
                  // }
                }}
                value={item.value}
              />
            ))}
          </Stack>
        </Radio.Group>
      </Stack> */}

      <ImagePicker
        accept={[MIME_TYPES.pdf, MIME_TYPES.doc, MIME_TYPES.docx]}
        {...propsfile}
        errorMessage={error}
        maxSize={2000000}
        onSelect={onSelect}
        // required
        setErrorMessage={setError}
      />

      <Field
        component={Checkbox}
        label="Saya yakin untuk memblokir pelanggan ini"
        name="agree"
        onClick={(e) => dispatch(change('FormBlockedNik', 'agree', e.target.checked))}
        styles={{
          body: {
            alignItems: 'center'
          },
          label: {
            color: '#212121',
            fontWeight: 400,
            fontSize: '14px'
          }
        }}
      />
      {isTooManyRequests
        && (
          <Banner
            className={styles.banner}
            desc={<>
              Sudah submit CSV 5 kali dalam satu menit.
              Anda dapat submit file CSV kembali setelah <strong>{minute}:{second}</strong></>}
            icon={<IconFailed />}
            type="danger" />
        )}

      <div className={styles.actions}>
        <Button fullWidth onClick={() => navigate('/customer-setting')} style={'outlined'} type="button">
          Batal
        </Button>
        <Button
          className={styles.btnAction}
          disabled={disabledButton() || isLoading}
          fullWidth
          style={'danger'}
          type="submit">
          {isLoading && <LoadingBars size={1} />}
          Blokir Pelanggan
        </Button>
      </div>

      <Modal
        centered
        onClose={() => setModalReasonDetail(false)}
        opened={modalReasonDetail}
        size="lg"
        styles={{ title: { fontSize: '20px', fontWeight: 600 } }}
        title="Pesan Keterangan Blokir di MAP">
        <Stack>
          <span className={styles.info}>Pilih keterangan blokir untuk ditampilkan di MAP.</span>
          <Radio.Group onChange={(value) => setReasonDetailId(value)} value={reasonDetailId}>
            <Stack mt="xs">
              {inputPropsDescription.data.map((item, index) => (
                <Radio checked={reasonDetailId === item.value} key={index}
                  label={item.label}
                  styles={{
                    label: {
                      fontSize: '14px',
                      fontWeight: 400,
                      color: '#212121',
                      lineHeight: '20px',
                    },
                    body: {
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #D9DEE4',
                      borderRadius: '8px',
                      padding: '0.3rem .5rem',
                    },
                    // inner: {
                    //   padding: '0.5rem',
                    // }
                  }}
                  value={item.value}
                />
              ))}
            </Stack>
          </Radio.Group>
        </Stack>
        <div className={styles.actions}>
          <Button fullWidth onClick={() => { setModalReasonDetail(false); setReasonDetailId(''); }} style={'outlined'} type="button">
            Tutup
          </Button>
          <Button
            disabled={!reasonDetailId}
            fullWidth
            onClick={() => {
              dispatch(change('FormBlockedNik', 'reasonDetailId', reasonDetailId));
              setModalReasonDetail(false);
            }}
            style={'danger'}
            type="button">
            Pilih Pesan Keterangan
          </Button>
        </div>
      </Modal>
    </form>
  );
}

Component.propTypes = {
  dataReason: PropTypes.array,
  dataReasonDetail: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  isBulk: PropTypes.bool,
  isLoading: PropTypes.bool,
  isTooManyRequests: PropTypes.bool,
  minute: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  second: PropTypes.string,
};

